/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Encart public "Héros du mois" pour la home pharmacie.
 * RGPD-friendly : initiale + prénom uniquement (sans photo, jusqu'à
 * consentement écrit obtenu pour une évolution future).
 */
const HeroOfMonthCard = () => {
  const [hero, setHero] = useState(null);
  const [period, setPeriod] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const r = await axios.get(`${API}/agent-performance/hero-of-month/public`);
        if (!alive) return;
        if (r.data?.hero) setHero(r.data.hero);
        setPeriod(r.data?.period || '');
      } catch (e) { /* silent */ }
      finally { if (alive) setLoading(false); }
    })();
    return () => { alive = false; };
  }, []);

  if (loading || !hero) return null;

  // Format period 'YYYY-MM' → 'mai 2025'
  const monthNames = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin',
    'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  const [y, m] = (period || '').split('-');
  const periodLabel = (m && y) ? `${monthNames[parseInt(m, 10) - 1]} ${y}` : '';

  return (
    <section
      className="py-12 px-4 bg-gradient-to-br from-[#FFF8F1] via-[#F5E6D3] to-[#FFF8F1]"
      data-testid="hero-of-month-card"
    >
      <div className="max-w-3xl mx-auto">
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-[#E8D5BC]">
          <div className="bg-gradient-to-r from-[#1B4D3E] to-[#0F3D32] px-6 py-3">
            <p className="text-xs uppercase tracking-widest text-emerald-100 font-medium">
              Reconnaissance équipe
            </p>
          </div>
          <div className="p-6 sm:p-8 flex flex-col sm:flex-row items-center gap-6">
            <div className="relative">
              <div className="w-24 h-24 rounded-full bg-gradient-to-br from-[#C9A086] to-[#A0826D] flex items-center justify-center text-white font-serif text-4xl font-bold shadow-md">
                {hero.initials}
              </div>
              <div className="absolute -top-2 -right-2 text-3xl">🏆</div>
            </div>
            <div className="flex-1 text-center sm:text-left">
              <p className="text-sm text-[#78716C] uppercase tracking-wider">Héros du mois</p>
              <h2 className="text-2xl sm:text-3xl font-serif font-semibold text-[#1B4D3E] mt-1">
                {hero.first_name}
                {periodLabel && <span className="text-[#A0826D] font-normal"> · {periodLabel}</span>}
              </h2>
              <p className="text-sm text-[#525252] mt-2 leading-relaxed">
                Un grand merci à notre conseiller·ère qui s'est distingué·e par sa
                rigueur, sa performance et son engagement quotidien au service de
                votre santé.
              </p>
              <div className="mt-3 inline-flex items-center gap-2 bg-emerald-50 text-emerald-800 px-3 py-1 rounded-full border border-emerald-200">
                <span className="text-xs font-medium">Score</span>
                <span className="text-lg font-mono font-bold">{hero.score}</span>
                <span className="text-xs">/100</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroOfMonthCard;
